import { Translation } from 'react-i18next';

import { mapTagsToLabels } from '@/features/fermentation/utils/tags-label-mapper';
import { Tags } from '@/features/single-measurement/types/tags';

export const TagList = ({ tags }: { tags?: Tags }) => {
  if (!tags) return null;

  const tagList = mapTagsToLabels(tags);

  const renderTagList = tagList.map((tag) => {
    return tag.value ? (
      <div key={tag.label} className="flex items-center">
        <span className="flex-1 font-bold text-black-dark">
          <Translation>{(t) => <>{t(tag.label)}</>}</Translation>
        </span>
        <span className="flex-1 text-black-dark font-thin capitalize">{tag.value}</span>
      </div>
    ) : null;
  });

  return <div className="grid grid-cols-2 gap-6">{renderTagList}</div>;
};
